import { getMaritalInfo, getMaritalHistory } from '@/api/marital'
export default {
    state: {
        maritalInfo: {},
        history: [],


    },

    mutations: {

        SET_MARITAL_INFO: (state, data) => {
            state.maritalInfo = data
        },
        SET_MARITAL_HISTORY: (state, data) => {
            state.history = data
        },

    },

    actions: {
        getMaritalInfo({ commit }) {

            return new Promise((resolve, reject) => {
                getMaritalInfo().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_MARITAL_INFO', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getMaritalHistory({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getMaritalHistory().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_MARITAL_HISTORY', data)
                    commit('SET_TABLE_TEXT', false)

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },

    }
}